import React, { useEffect, useRef } from "react";
import ShopCartItem from "./shopCartItem";
import ShopCartTotal from "./shopCartTotal";
import ShopCartPaymentInfo from "./shopCartPaymentInfo";
import { useSelector, useDispatch } from "react-redux";
import {
  getOrder,
  getOrderIsLoading,
  getPayUrl,
  getLastOrderError,
  getOrderError,
  receiveRegionList,
  getCurrentRegion,
} from "../../store/order";
import Loader from "../loader";
import { useModal } from "../../hooks/useModal";

function ShopCart({ shop, additionalRegionInfo }) {
  const dispatch = useDispatch();
  const isLoadingOrder = useSelector(getOrderIsLoading(shop));
  const order = useSelector(getOrder(shop));
  const currentRegion = useSelector(getCurrentRegion(shop));
  const payUrl = useSelector(getPayUrl(shop));
  const lastOrderError = useSelector(getLastOrderError(shop));
  const orderError = useSelector(getOrderError(shop));
  const { openModal } = useModal();
  const openModalRef = useRef(openModal);
  openModalRef.current = openModal;

  const handleRetry = () => {
    dispatch(receiveRegionList(shop));
  };

  useEffect(() => {
    if (orderError) {
      openModalRef.current(orderError);
    }
  }, [orderError]);

  return (
    <>
      {Object.entries(order).length > 0 && (
        <div className=" w-full">
          <div className=" flex items-center justify-between">
            <h2 className=" text-2xl font-medium">{order.orderTitle}</h2>
          </div>
          {additionalRegionInfo?.[currentRegion] && (
          <div className=" flex items-center justify-between text-sm font-light">
            <h3 className=" text-sm font-light">{additionalRegionInfo[currentRegion]}</h3>
          </div>
          )}

          <div className=" flex flex-col gap-4 lg:flex-row">
            <div className=" w-full lg:w-2/3  xl:w-3/4">
              {order.itemList?.map((item, index) => (
                <ShopCartItem item={item} key={index} shop={shop} />
              ))}
            </div>
            <div className=" w-full lg:w-1/3 xl:w-1/4 ">
              <ShopCartTotal cart={order.cart} shop={shop} />
            </div>
          </div>

          {payUrl && (
            <div className=" w-full ">
              <ShopCartPaymentInfo shop={shop} />
            </div>
          )}
        </div>
      )}
      {Object.entries(order).length === 0 && lastOrderError && !isLoadingOrder && (
        <div className="w-full rounded-lg border border-red-300 bg-red-50 px-4 py-3 text-center text-sm text-red-700">
          <p className="mb-3">Не удалось загрузить данные магазина.</p>
          <button
            type="button"
            className="inline-flex items-center justify-center rounded-md bg-red-600 px-4 py-2 text-xs font-semibold text-white shadow-sm transition hover:bg-red-700"
            onClick={handleRetry}
          >
            Обновить
          </button>
        </div>
      )}
      { isLoadingOrder && (<Loader loading={isLoadingOrder} />) }
    </>
  );
}

export default ShopCart;
